

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NewsItemComponent from '../components/NewsItemComponent';
import { /* setVote , */ countNewsView } from '../actions/NewsActions';

const mapStateToProps = (state) => ({
    breakpoint: state.breakpointReducer,
});

const mapDispatchToProps = (dispatch) => ({
    /* setVote: (vote, idNews, callback) => {
        dispatch(setVote(vote, idNews, callback));
    },
    */
    countNewsView: (newsView) => {
        dispatch(countNewsView(newsView));
    },
});

const NewsItemContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewsItemComponent);

export default withRouter(NewsItemContainer);
